export const USER_LEVELS = ["everyone", "subscriber", "vip", "moderator", "broadcaster"];
export const USER_LEVEL_HIERARCHY = {
    everyone: 0,
    subscriber: 1,
    vip: 2,
    moderator: 3,
    broadcaster: 4,
};
export const DEFAULT_COMMAND_COOLDOWN = 5;
export const DEFAULT_TIMER_INTERVAL = 15;
export const DEFAULT_TIMER_MIN_LINES = 5;
export const DEFAULT_COMMAND_PREFIX = "!";
// Full scopes for broadcasters/bot owners
export const TWITCH_SCOPES = [
    "chat:read",
    "chat:edit",
    "channel:moderate",
    "moderator:manage:banned_users",
    "moderator:manage:chat_messages",
    "moderator:read:followers",
    "channel:read:subscriptions",
    "channel:read:hype_train",
    "channel:read:redemptions",
    "channel:manage:redemptions",
    "user:manage:whispers",
    "user:read:moderated_channels",
    "channel:read:polls",
    "channel:read:predictions",
    "moderator:manage:shoutouts",
    // !raid / !unraid and !game (auto category switch). Like the shoutout scope,
    // the broadcaster must log in once more after this is added for the stored
    // token to actually carry it.
    "channel:manage:raids",
    "channel:manage:broadcast",
    // !clip — same re-login caveat. (!mark needs channel:manage:broadcast above.)
    "clips:edit",
];
// Minimal scopes for viewers. Deliberately EMPTY: a user token identifies its
// owner via /helix/users without any scope at all, so the marketplace and the
// casino need nothing more. Requesting `user:read:email` here handed us 20
// addresses the app never read once (pipel1n3: "mehr Datenschutz, less scopes
// needed for marketplace"). Don't add a scope back without a caller for it.
export const TWITCH_VIEWER_SCOPES = [];
// Custom API Variables
export const CUSTOM_API_TIMEOUT_MS = 5000;
export const CUSTOM_API_CACHE_TTL = 30;
export const CUSTOM_API_MAX_RESPONSE_LENGTH = 400;
// Alert Types
export const ALERT_TYPES = [
    "firstchat",
    "autoresponse",
    "addiction",
    "follow",
    "sub",
    "giftsub",
    "raid",
    "hypetrain",
    "command",
    "sound",
    // Ko-fi donations — configured like any other alert, so the sound, image and
    // duration come from the same editor rather than from a second settings page.
    "tip",
];
// Animation Types
export const ANIMATION_TYPES = ["slide", "fade", "bounce", "zoom"];
// Overlay Fonts
export const OVERLAY_FONTS = [
    "Segoe UI",
    "Arial",
    "Georgia",
    "Impact",
    "Comic Sans MS",
    "Roboto",
    "Open Sans",
    "Montserrat",
    "Poppins",
    "Oswald",
    "Lobster",
    "Bebas Neue",
    "Bangers",
    "Permanent Marker",
    "Press Start 2P",
];
// Google Fonts (subset of OVERLAY_FONTS that need loading)
export const GOOGLE_FONTS = [
    "Roboto",
    "Open Sans",
    "Montserrat",
    "Poppins",
    "Oswald",
    "Lobster",
    "Bebas Neue",
    "Bangers",
    "Permanent Marker",
    "Press Start 2P",
];
// Default Overlay Layout
export const DEFAULT_LAYOUT_CONFIG = {
    version: 1,
    canvas: { width: 1920, height: 1080, background: "transparent" },
    elements: [
        {
            type: "image",
            id: "image-1",
            x: 710,
            y: 90,
            width: 500,
            height: 500,
            zIndex: 1,
            borderRadius: 12,
            borderWidth: 0,
            borderColor: "#ffffff",
            objectFit: "contain",
        },
        {
            type: "text",
            id: "text-1",
            x: 360,
            y: 650,
            width: 1200,
            height: 100,
            zIndex: 2,
            fontFamily: "Segoe UI",
            fontSize: 32,
            fontWeight: "bold",
            fontStyle: "normal",
            color: "#ffffff",
            textAlign: "center",
            textShadow: "2px 2px 8px rgba(0,0,0,0.8)",
            textStroke: "",
            backgroundColor: "rgba(0,0,0,0.5)",
            padding: 12,
            borderRadius: 12,
        },
    ],
};
// Channel Points Reward Action Types
export const REWARD_ACTION_TYPES_AVAILABLE = ["sound", "video", "alert", "command", "chat_message"];
// Overlay video playback (channel point "video" action, video !sound commands)
export const VIDEO_POSITIONS = ["center", "top-left", "top-right", "bottom-left", "bottom-right"];
// Where an alert popup sits on screen. "center" keeps a custom layout exactly as
// placed in the editor; any other value moves its elements to that edge/corner.
export const ALERT_POSITIONS = ["center", "top", "bottom", "top-left", "top-right", "bottom-left", "bottom-right"];
// Upload Limits
export const UPLOAD_LIMITS = {
    sound: {
        maxSizeBytes: 5 * 1024 * 1024, // 5MB
        // .mp4/.m4a/.aac: audio track is extracted server-side to MP3
        allowedExtensions: [".mp3", ".wav", ".ogg", ".webm", ".mp4", ".m4a", ".aac"],
        allowedMimeTypes: ["audio/mpeg", "audio/wav", "audio/ogg", "audio/webm", "video/mp4", "audio/mp4", "audio/aac"],
    },
    image: {
        maxSizeBytes: 2 * 1024 * 1024, // 2MB
        allowedExtensions: [".png", ".jpg", ".jpeg", ".gif", ".webp"],
        allowedMimeTypes: ["image/png", "image/jpeg", "image/gif", "image/webp"],
    },
    video: {
        maxSizeBytes: 100 * 1024 * 1024, // 100MB
        // .mov (iPhone/HEVC) is converted to H.264 MP4 server-side
        allowedExtensions: [".webm", ".mp4", ".mov"],
        allowedMimeTypes: ["video/webm", "video/mp4", "video/quicktime"],
    },
};
//# sourceMappingURL=constants.js.map